/* eslint-disable prettier/prettier */
import React, { Suspense, useEffect } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { CSpinner, useColorModes } from '@coreui/react'
import './scss/style.scss'

// We use those styles to show code examples, you should remove them in your application.
import './scss/examples.scss'
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import Swal from 'sweetalert2'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const Gateway = React.lazy(() => import('./views/pages/aprovacoes/gateway'))

// Telas de destino
const Viagem = React.lazy(() => import('./views/pages/aprovacoes/viagem'))
const Reembolso= React.lazy(() => import('./views/pages/aprovacoes/reembolso'))
const CentralCadastro = React.lazy(() => import('./views/pages/aprovacoes/centraldecadastro'))
const Chamados = React.lazy(() => import('./views/pages/aprovacoes/chamados'))
const Saida = React.lazy(() => import('./views/pages/aprovacoes/autorizacaoSaida'))
const LiberacaoEquipamento = React.lazy(() => import('./views/pages/aprovacoes/liberacaoequipamento'))

const App = () => {
  const { isColorModeSet, setColorMode } = useColorModes('coreui-free-react-admin-template-theme')
  const storedTheme = useSelector((state) => state.theme)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1])
    const theme = urlParams.get('theme') && urlParams.get('theme').match(/^[A-Za-z0-9\s]+/)[0]
    if (theme) {
      setColorMode(theme)
    }

    if (isColorModeSet()) {
      return
    }
    setColorMode(storedTheme)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps


 useEffect(() => {
  const host = window.location.host;
  // Só aplica em produção
  if (!host.includes('localhost')) {
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && e.key === 'I') ||
        (e.ctrlKey && e.shiftKey && e.key === 'J') ||
        (e.ctrlKey && e.key === 'U')
      ) {
        e.preventDefault();
        e.stopPropagation();
        console.clear();
      }
    };

    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    let devtoolsDetected = false;
    const devtoolsCheck = setInterval(() => {
      const before = new Date().getTime();
      const after = new Date().getTime();
      if (after - before > 100) {
        devtoolsDetected = true;
      }
      const el = new Image();
      Object.defineProperty(el, 'id', {
        get: function () {
          devtoolsDetected = true;
          throw new Error('DevTools detected');
        },
      });

      if (devtoolsDetected) {
        alert('Uso não autorizado detectado. Você será desconectado.');
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/login';
      }
    }, 1000);

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('contextmenu', handleContextMenu);
    console.clear();

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('contextmenu', handleContextMenu);
      clearInterval(devtoolsCheck);
    };
  }
}, []);

  return (
    <HashRouter>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        <Routes>
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="/gateway/:id/:matricula" element={<Gateway />} />
          <Route path="/aprovacao/centraldecadastro" element={<CentralCadastro />} />
          <Route path="/aprovacao/chamados" element={<Chamados />} />
          <Route path="/aprovacao/reembolso" element={<Reembolso />} />
          <Route path="/aprovacao/viagem" element={<Viagem />} />
          <Route path="/aprovacao/saida" element={<Saida />} />
          <Route path="/aprovacao/liberacaoequipamento" element={<LiberacaoEquipamento />} />
          <Route exact path="*" name="Inicio" element={<DefaultLayout />} />
          <Route exact path="/login" name="Login Page" element={<Login />} />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}

export default App
